export const FLIGHTS_DIALOG_COPY = {
  title: 'Información de Vuelos',
  subtitle: 'Consulta datos de vuelos y pasajeros asignados por tramo.',
  footerClose: 'Cerrar',
  fallbackDash: '-',
  loading: 'Cargando vuelos…',
  loadingHint: 'Estamos obteniendo la información del itinerario.',
  empty: 'No hay vuelos registrados para este file.',
  emptyHint: 'Los vuelos aparecerán aquí cuando se registren en Sales.',
  flightsChipLabel: 'Vuelos',
  paxPanelTitle: 'Pasajeros del vuelo',
  paxPanelClose: 'Ocultar listado',
  paxViewList: 'Ver listado',
  paxCountSingular: 'pasajero',
  paxCountPlural: 'pasajeros',
  paxPanelHint: 'Selecciona un vuelo para ver el listado completo.',
} as const;

export const FLIGHTS_TABLE_HEADERS = {
  NroVuelo: 'Número De Vuelo',
  aerolinea: 'Aerolinea',
  status: 'Status',
  fechaVuelo: 'Fecha de Vuelo',
  departureTime: 'Hora De Despegue',
  arrivalTime: 'Hora de Arrivo',
  origen: 'Origen',
  destino: 'Destino',
  pax: 'Pasajeros',
} as const;

export const FLIGHTS_DISPLAYED_COLUMNS = [
  'NroVuelo',
  'aerolinea',
  'status',
  'fechaVuelo',
  'departureTime',
  'arrivalTime',
  'origen',
  'destino',
  'pax',
] as const;
